module.exports = __webpack_public_path__ + "static/media/arrow-right.dae0c3c9.svg";